import moment from 'moment';
import { PodcastResult, UpdatePodcastPictureResult } from '../api-results/podcast.api-result';
import { PodcastType } from '../enums/podcast.enum';
import { PodcastFormValue, UpdatePodcastPayload } from '../payloads/podcast.payload';
import { Course } from './course.entity';

export class Podcast {
  id: string;
  type: PodcastType;
  title: string;
  content: string;
  course: Course;
  picture: string;
  createdAt: Date;
  totalViews: number;

  constructor(result: PodcastResult) {
    this.id = result.id;
    this.type = result.type;
    this.title = result.title;
    if (result.content)
      this.content = result.content.replace(/style="(.*?)"/, '').replace(/style="(.*?)"/, '');
    if (result.course) this.course = new Course(result.course);
    this.picture = result.picture
      ? result.picture
      : 'assets/assets-site/images/logos/logo_1024.png';

    if (result.createdAt) {
      this.createdAt = moment(result.createdAt).toDate();
    }
    this.totalViews = result.totalViews;
  }

  toFormValue(): PodcastFormValue {
    return {
      title: this.title,
      type: this.type,
      content: this.content,
      course: this.course,
      picture: {
        file: null,
        path: this.picture,
      },
    };
  }

  static updatedEntityToResult(
    payload: UpdatePodcastPayload,
    formValue: PodcastFormValue,
    updatePictureResult: UpdatePodcastPictureResult
  ): Partial<PodcastResult> {
    return {
      title: payload.title,
      content: payload.content,
      course: formValue.course.toResult(),
      picture: updatePictureResult.picture,
    };
  }
}
